import { render, staticRenderFns } from "./MMaterialEdit.vue?vue&type=template&id=bfe0b658&scoped=true&"
import script from "./MMaterialEdit.vue?vue&type=script&lang=ts&"
export * from "./MMaterialEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MMaterialEdit.vue?vue&type=style&index=0&id=bfe0b658&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe0b658",
  null
  
)

export default component.exports